// TODO Rethink how this is structured
import { STYLE_COMMANDS } from '../../richText/richTextConstants';

export const CHECKLIST_BLOCK_TYPE = STYLE_COMMANDS.CHECKLIST;
